import { useMemo } from 'react';
import { useIntl } from 'react-intl';

// project import
import { cn } from 'utils/cn';
import DrawerContent from './DrawerContent';
import DrawerHeader from './DrawerHeader';

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

interface Props {
    open: boolean;
    handleDrawerToggle?: () => void;
}

// A 230px drawer when open and a 48px rail when collapsed; the page content takes the rest of the row.
function MainDrawer({ open, handleDrawerToggle }: Props) {
    const intl = useIntl();
    const drawerContent = useMemo(() => <DrawerContent />, []);

    return (
        <nav className="z-(--z-drawer) shrink-0" aria-label={intl.formatMessage({ id: 'navigation' })}>
            <div
                className={cn(
                    'bg-sidebar text-fg flex h-full flex-col overflow-x-hidden whitespace-nowrap transition-[width] ease-[cubic-bezier(0.4,0,0.6,1)]',
                    open
                        ? 'border-sidebar-border w-[230px] border-r duration-225'
                        : 'shadow-card-raised w-12 duration-195'
                )}
            >
                <DrawerHeader open={open} handleDrawerToggle={handleDrawerToggle} />
                {drawerContent}
            </div>
        </nav>
    );
}

export default MainDrawer;
